import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AkitExerciseComponent } from './components/akit-exercise/akit-exercise.component';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { AlgebraKiTService } from './services/algebrakit.service';
import { AkitInteractionComponent } from './components/akit-interaction/akit-interaction.component';
import { AkitInteractionEditorComponent } from './components/akit-interaction-editor/akit-interaction-editor.component';
import { AkitFormulaEditorComponent } from './components/akit-formula-editor/akit-formula-editor.component';
import { AkitExerciseEditorComponent } from './components/akit-exercise-editor/akit-exercise-editor.component';
// import { FieldFormatPipe } from './field-format-pipe';

@NgModule({ declarations: [
        AkitExerciseComponent,
        AkitInteractionComponent,
        AkitInteractionEditorComponent,
        AkitExerciseEditorComponent,
        AkitFormulaEditorComponent,
        SafeHtmlPipe
    ],
    exports: [AkitExerciseComponent, AkitInteractionComponent, AkitInteractionEditorComponent, AkitFormulaEditorComponent, AkitExerciseEditorComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule], providers: [
        AlgebraKiTService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AlgebraKITModule { }
